import { Component, AfterViewInit, ViewContainerRef, NgZone, ChangeDetectorRef, } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import {
  TdLoadingService, TdMediaService, TdDialogService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
} from '@covalent/core';

import { Vacuna, Dosis } from '../../../models/';
import { VacunasService, LoginService } from '../../../services/';
import { VacunasDetalleComponent } from './detallevacunas/detallevacunas.component';

@Component({
  selector: 'qs-vacunas',
  templateUrl: './vacunas.component.html',
  styleUrls: ['./vacunas.component.scss'],
  viewProviders: [VacunasService],
})

export class VacunasComponent implements AfterViewInit {

  public idPaciente: string;
  public vacunas: Vacuna[];
  public isSmallScreen: boolean = false;
  public _querySubscription: Subscription;

  public columnsAll: ITdDataTableColumn[] = [
    { name: 'fecha', label: 'Fecha', tooltip: 'Fecha', sortable: false },
    { name: 'nombre', label: 'Nombre', sortable: true },
    { name: 'enfermedades', label: 'Enfermedades', sortable: true },
    { name: 'listadosis', label: 'Lista Dosis', sortable: false, hidden: true },
  ];

  public columns: ITdDataTableColumn[] = this.columnsAll;
  // Datos
  public filteredData: Vacuna[] = [];
  public filteredDataTotal: number;

  // Propiedades
  public clickable: boolean = true;
  public selectable: boolean = false;
  public sortable: boolean = true;
  public sortBy: string = 'fecha';
  public sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  public searchTerm: string = '';

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _vacunasService: VacunasService,
    private _loginService: LoginService,
    private _dataTableService: TdDataTableService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService, ) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this._titleService.setTitle('Vacunas');
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('vacunas.load');
    this._vacunasService.obtenerVacunasPaciente(this.idPaciente).subscribe((res: any) => {
      this.vacunas = res.respuesta.vacunas || [];
      this.filteredData = this.vacunas;
      this.filteredDataTotal = this.vacunas.length;
      this._loadingService.resolve('vacunas.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo vacunas.', 'OK', 6000);
      this._loadingService.resolve('vacunas.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  openDosis($event: any): void {
    let vacuna: Vacuna = $event;
    let dialogRef: any = this._dialogService.open(VacunasDetalleComponent, {
      data: vacuna,
      width: '75%',
      role: 'dialog',
    });
    dialogRef.componentInstance.vacuna = vacuna;
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.vacunas;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/vacunas/vacunas.component.ts